import React, { useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';

import { ButtonV2 } from 'components/common/ui';
import { FileDropZone } from 'components/common/media';
import { FieldV2 } from 'components/common/form-controls';
import { ModalFooter, ModalFormSection } from 'components/common/modals';

import userMediaUploadDocumentFormValidationSchema from './userMediaUploadDocumentFormValidationSchema';
import styles from './userMediaUploadDocumentForm.styles';
import { USER_DOCUMENT_TYPES } from './constants';

const UserMediaUploadDocumentForm = ({
  defaultValues = {},
  isLoading,
  onCancel,
  onSubmit,
}) => {
  const [documents, setDocuments] = useState([]);

  const resolver = yupResolver(userMediaUploadDocumentFormValidationSchema);

  const methods = useForm({ defaultValues, resolver });

  const handleDocuments = (files) => {
    setDocuments([...files]);
  };

  const handleSubmit = (values) => {
    onSubmit({ ...values, documents });
  };

  const isDisabledSubmit =
    isLoading || methods.formState.isSubmitting || documents.length === 0;

  return (
    <FormProvider {...methods}>
      <form
        id="upload-user-media-document-form"
        onSubmit={methods.handleSubmit(handleSubmit)}
      >
        <ModalFormSection>
          <FieldV2
            isRequired
            label="Document Type"
            type="dropdown"
            control={methods.control}
            name="type"
            options={USER_DOCUMENT_TYPES}
          />
          <FileDropZone
            previewFiles={false}
            callBack={handleDocuments}
            currentFiles={documents}
            accept={{
              'image/png': ['.png'],
              'image/jpg': ['.jpg'],
              'image/jpeg': ['.jpeg'],
              'application/pdf': ['.pdf'],
            }}
            styles={styles}
          />
        </ModalFormSection>
        <ModalFooter>
          <ButtonV2 type="button" variant="outlined" onClick={onCancel}>
            Cancel
          </ButtonV2>
          <ButtonV2
            form="upload-user-media-document-form"
            type="submit"
            loading={isLoading}
            disabled={isDisabledSubmit}
          >
            Save
          </ButtonV2>
        </ModalFooter>
      </form>
    </FormProvider>
  );
};

export default UserMediaUploadDocumentForm;
